<template>
    <div class="newProductList" id="shejishow">
        <loading style="margin-top:60px;padding-bottom:80px;background: #fff;" v-if="busy"></loading>
        <div class="main">
            <div class="AllNew">
                <div v-if="!busy && dataList">
                    <p>全部案例</p>
                    <div class="list">
                        <home-cart v-for="(item, index) in dataList"
                                   :key = index
                                   :msgData="item"
                                   :webCoverFileImg="item.showCoverFile"
                                   :paddingLeft="0"
                                   :paddingUp="0"
                                   :height="276"
                                   :width="540"
                                   :borderPadding="10"
                                   :isShowDetail=false
                                   :isCollection=false
                                   :designShowDetail=true
                                   :isExternalUrl=true
                        ></home-cart>
                    </div>
                </div>
                <div class="page" v-show="!busy && dataList">
                    <Page   :page-size="pageSize"
                            @on-change="changePage"
                            :total="totalNum"></Page>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '../../../../../../src/api'
    import homeCart from '../../../../../../src/components/common/homeCard.vue'
    import loading from '../../../../../../src/components/common/loading.vue'
    export default {
        data(){
            return {
                dataList: null,
                pageNum: 1,
                pageSize: 10,
                totalNum: 0,
                bgColor: '#fff',
                busy: false
            }
        },
        components: {homeCart, loading},
        methods: {
            page_materal() {
                this.busy = true;
                api.homePage.show_page(this.pageNum,this.pageSize,0)
                    .then(res => {
                        this.dataList = res.designerShowResponseVOList;
                        this.totalNum = res.designerShowResponseVOList[0].totalNum;
                        this.busy = false;
                    })
            },
            changePage(current) {
                this.pageNum = current
                this.page_materal()
            },
        },
        created() {
            this.page_materal();
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .newProductList{
        width: 100%;
        margin-top: 40px;
        .main{
            width: 100%;
            .AllNew{
                width: 100%;
                text-align: left;
                p{
                    font-size: 28px;
                    color: #6C6F70;
                    margin-bottom: 10px;
                    padding: 0 3px;
                }
                .list{
                    width: 100%;
                }
                .page{
                    margin:40px auto;
                    text-align: center;
                }
            }
        }
    }
</style>
<style>
    #shejishow .vue-css-scale img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
</style>